import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';
import FAQListRow from '../../components/FAQListRow/FAQListRow';
import FAQListRowSkeleton from '../../components/FAQListRowSkeleton/FAQListRowSkeleton';
import manageFAQStore from '../../store/manageFAQStore';
import { FAQSortColumn } from '../../types/manageFAQ';
import { localeStore } from 'src/mobx/localesStore';
import { emptyArray } from 'src/utils/helpers';
import { Icons } from '~/assets/fonts/Icons/icons';
import { formatImagePath } from '~/utils/formatter';
import Pagination from '~/view/components/Controls/PaginationOld/PaginationOld';
import GridTable, { TGridColumnTitle } from '~/view/containers/GridTable';

const ManageFAQList: React.FC = observer((): JSX.Element => {
  const { filters, pagination, isLoading } = manageFAQStore;

  const noFoundText: string = localeStore.t(filters.search || filters.status !== undefined ? 'no_results_found' : 'no_items_yet');
  const isNoFound: boolean = !pagination.total && !isLoading;
  const isFirstLoading: boolean = Boolean(isLoading && !pagination.total);

  useEffect(() => {
    manageFAQStore.getFAQList(1);
  }, []);

  const columnTitles = useMemo((): TGridColumnTitle<FAQSortColumn>[] => {
    return [{ title: 'no', columnName: FAQSortColumn.NO }, { title: 'question' }, { title: 'answer' }, { title: 'status' }];
  }, []);

  return (
    <div className="d-flex flex-column flex-grow-1">
      {isNoFound ? (
        <div className="d-flex flex-column justify-content-center align-items-center mt-6">
          <img src={formatImagePath(`${Icons.NoResults}.svg`)} alt="no_results_found" className="image__no-found mb-6" />
          <p className="family-medium text-size-24 color-gray2">{noFoundText}</p>
        </div>
      ) : (
        <GridTable
          gridTemplateClass="faq-list-row__grid-template pr-4"
          columnTitles={columnTitles}
          filters={filters}
          setFilters={manageFAQStore.setFilters}
        >
          {isFirstLoading
            ? emptyArray().map((_, index) => <FAQListRowSkeleton key={'skeleton-' + String(index)} />)
            : pagination.data.map((FAQ) => <FAQListRow key={FAQ.id} FAQ={FAQ} />)}
        </GridTable>
      )}

      <Pagination
        type="arrow"
        pagination={pagination}
        onChange={manageFAQStore.getFAQList}
        loading={manageFAQStore.loading}
        showPaginationInfo
        showMorePageButtons
      />
    </div>
  );
});

export default ManageFAQList;
